/**
 * ReprocessamentosPage — rota /reprocessamentos (admin; ADR-036, Req 5.4, design §5): os reprocessamentos recentes,
 * para achar de novo o que foi disparado — quando (link para o acompanhamento), a ação, o conjunto, quem disparou,
 * o andamento e quantas visitas mudaram. Paginação pelo cursor do contrato (`GET /reprocessamentos`).
 *
 * A guarda de perfil (só admin) vive na rota (ProtectedRoute).
 */

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useListaReprocessamentos } from '../hooks/usePainel';
import { Pager } from '../components/ConsultaShared';
import { formatarData } from '../components/format';
import {
  CLASSE_ANDAMENTO,
  ROTULO_ACAO,
  ROTULO_ANDAMENTO,
  descreverConjunto,
} from '../components/reprocessamentoTextos';

const numero = new Intl.NumberFormat('pt-BR');

export function ReprocessamentosPage(): JSX.Element {
  const [page, setPage] = useState(1);
  const { pagina, carregando, erro } = useListaReprocessamentos(page > 1 ? String(page) : undefined);
  const itens = pagina?.itens ?? [];

  return (
    <div>
      <h1 className="page-title">Reprocessamentos</h1>
      <p className="page-subtitle">
        Os reprocessamentos disparados pela ficha, pela lista de visitas e pelo painel — o mais recente primeiro.
      </p>

      <section className="card">
        {carregando && <p className="muted">Carregando…</p>}
        {erro && <p className="notice">Não foi possível carregar os reprocessamentos.</p>}
        {!carregando && !erro && itens.length === 0 && <p className="muted">Nenhum reprocessamento ainda.</p>}
        {itens.length > 0 && (
          <table className="table">
            <thead>
              <tr>
                <th>Quando</th>
                <th>Ação</th>
                <th>Conjunto</th>
                <th>Quem disparou</th>
                <th>Andamento</th>
                <th>Mudaram</th>
              </tr>
            </thead>
            <tbody>
              {itens.map((r) => (
                <tr key={r.reprocessamentoId}>
                  <td>
                    <Link to={`/reprocessamentos/${r.reprocessamentoId}`}>{formatarData(r.criadoEm)}</Link>
                  </td>
                  <td>{ROTULO_ACAO[r.modo]}</td>
                  <td>{descreverConjunto(r.criterio)}</td>
                  <td>{r.disparadoPor ?? '—'}</td>
                  <td>
                    <span className={CLASSE_ANDAMENTO[r.status]}>{ROTULO_ANDAMENTO[r.status]}</span>{' '}
                    <span className="muted">{`${numero.format(r.processadas)} de ${numero.format(r.afetadas)}`}</span>
                  </td>
                  <td>{numero.format(r.mudaram)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <Pager page={page} temProxima={!!pagina?.nextCursor} onMudar={setPage} />
      </section>
    </div>
  );
}
